import axios from "axios";
import qs from 'qs'
import { store } from "Store/store.index";
import { baseUrlApis } from "./index";
import { URL_APPSTORE_API  } from './constants'
import { HttpRequest } from './request.utils'
import { isCNDomain, isJPDomain } from "@/utils/utils";
const REQUEST_APIS = {
    baseUrl: "",
    baseHttpUrl: "",
    edu:'api/appstore/edu',
    stripeKey: "api/appstore-subscription/get-stripe-public-key",
    userSubscribeOnlineInfo:'api/appstore/get-user-phantom-online-subscription',
    redeem:'api/appstore/redeem-phantom-subscription',
    userAppMy:'api/appstore/app/my',
    plan: "api/appstore-subscription/get-plan",
    getUserMetadata: "/api/auth/get-user-metadata",
    setUserMetadata: "/api/auth/set-user-metadata",
};
function _GetPlatformToken(flag, preload){
    if( preload ){
      return store.userStore.token ||store.userStore.tokenCache;
    }
    if (!flag) {
        return store.userStore.token;
    }
    // 8003 5dbf8cd15764542e96a30fcb
    // 8081 5dbf8765a09af17dfce13d76
    return '5dbf986c603d5c6237f37ea0';
}
export class AppStoreCloudApis extends HttpRequest {
    constructor() {
        super();
        this.CPDFURI = '';
        this.stripe = ''
    }
    initialize = () => {
        return new Promise((resolve)=>{
          try {
              baseUrlApis.getBaseUrlBy(URL_APPSTORE_API).then((data) => {
                  this.CPDFURI = data;
                  // 8003 8081
                  //this.CPDFURI = 'http://10.103.4.236:8003';
                  let axiosClient = axios.create({
                      baseURL: this.CPDFURI,
                  });
                  super.initialize(axiosClient, () => {
                      this.interceptorsFn();
                  });
                  resolve();
                  //interceptorsFn(this.apisAxios);
              });
          } catch (error) {
              throw error;
          }

        })
    }

    doCheckEdu = (preload) => {
        //api接口地址: /api/appstore/edu (例如:https://appstore-docker.connectedpdf.com:443/api/appstore/edu?access-token=5e719e85603d5c04cb2719e5)
        const url = `/${REQUEST_APIS.edu}?access-token=${_GetPlatformToken(false, preload)}&_=${(new Date()).valueOf()}`;
        return this.get({ url }).then((result) => {
            if (!result || result.ret === void 0) {
                throw result;
            }
            return result.ret;
        });
    }

    getPhantomOnlineSub = (preload)=>{
        const url = `/${REQUEST_APIS.userSubscribeOnlineInfo}?access-token=${_GetPlatformToken(false, preload)}&_=${(new Date()).valueOf()}`;
        return this.get({ url }).then((result) => {
            if (!result || result.ret !== 0) {
                throw result;
            }
            return result;
        })
    };

    /**
     *
     *
     * @returns {{app_code, plans}}
     */
    getPlan = (app_code, lang) => {
        let token =  _GetPlatformToken();

        return new Promise((resolve, reject) =>{
            let url = `/${REQUEST_APIS.plan}?`+ '&app_code=' + app_code+'&lang='+lang+ '&access-token=' + token;
            this.get({ url }).then((result)=>{
                if(Array.isArray(result)){
                    return resolve({ app_code, plans:result})
                }
                return resolve({ app_code, plans:[] });
                // if(!result || result.ret != 0){
                //     return;
                // }
                // return resolve(result);
            }).catch((err)=>{reject(err)});
        })
    };
    // TODO
    doGetStripeKey = ()=>{
        // if(this.stripe){
        //     return Promise.resolve(this.stripe);
        // }
        return new Promise(  (resolve, reject)=>{
            let url = `/${REQUEST_APIS.stripeKey}?access-token=${_GetPlatformToken()}&_=${(new Date()).valueOf()}`;
            this.get({ url }).then((key)=>{
                return resolve(key);
            }).catch((err)=>{
                reject(err)
            });
        });
    }

    doLicenseCodeRedeem = (licenseCode)=>{
        // gaParam
        var license_code = encodeURIComponent(licenseCode);
        return new Promise((resolve, /* reject */)=>{
            let url = `/${REQUEST_APIS.redeem}?access-token=${_GetPlatformToken()}&license_code=${license_code}&_=${(new Date()).valueOf()}`;
            if (!isCNDomain() && !isJPDomain()) {
                url += '&trackingId=phantompdf_online';
            }
            this.get({ url }).then((result)=>{
                return resolve(result);
            }).catch((err)=>{resolve(err)});
        });
    }

    setUserMetadata = async (key='', value='')=>{
        let url = `${REQUEST_APIS.setUserMetadata}?access-token=${_GetPlatformToken()}`;
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let params = {
          project: 'phantompdf_online',
          key,
          value
        }

        let data = qs.stringify(params);
        try {
          let result = await this.post( {url, data, config});
          return result;
        } catch (error) {
          throw error;
        }
    }

    getUserMetadata = async (key='')=>{
        let params = {
          'project': 'phantompdf_online',
          'key':key,
          'access-token':_GetPlatformToken()
        }

        let data = qs.stringify(params);
        let url = `${REQUEST_APIS.getUserMetadata}?${data}`;
        url && url;
        try {
          let result = await this.get( {url});
          return result;
        } catch (error) {
          throw error;
        }
    }
}